const DEFAULT_STEP_CARDS = [
  { step: 1, title: 'Company formation checklist', instructions: '', statusMessage: '' },
  { step: 2, title: 'Post Formation documents', instructions: '', statusMessage: 'Post-formation documents in progress', documentFolder: 'Post Formation documents' },
  { step: 3, title: 'Tax ID (EIN)', instructions: '', statusMessage: 'Applying for EIN', documentFolder: 'Tax ID (EIN)' },
];

export const formatTemplate = (template, vars = {}) =>
  (template || '').replace(/\{(\w+)\}/g, (_, key) => (vars[key] !== undefined ? vars[key] : `{${key}}`));

export const getUsaFormationPageMeta = (content) => {
  const stepCards = (content?.stepCards?.length ? content.stepCards : DEFAULT_STEP_CARDS).map((card, index) => ({
    ...DEFAULT_STEP_CARDS[index],
    ...card,
  }));

  return {
    pageBadgeLabel: content?.pageBadgeLabel || 'USA Company Formation',
    instructionBanner: content?.instructionBanner || '',
    loadingMessage: content?.loadingMessage || 'Loading your USA company formation data...',
    errorRetryLabel: content?.errorRetryLabel || 'Retry',
    stepCards,
    forms: content?.forms || {},
    checklistModal: { ...(content?.checklistModal || {}) },
    stepCardLabels: { ...(content?.stepCardLabels || {}) },
    pdf: { ...(content?.pdf || {}) },
    toasts: { ...(content?.toasts || {}) },
  };
};

export const mergeUsaFormationSteps = (apiSteps, stepCards) => {
  const cards = stepCards?.length ? stepCards : DEFAULT_STEP_CARDS;
  if (!Array.isArray(apiSteps) || !apiSteps.length) {
    return cards.map((card) => ({
      step: card.step,
      title: card.title,
      status: card.step === 1 ? 'in-progress' : 'pending',
      progress: 0,
      answers: card.step === 1 ? {} : undefined,
      comments: card.step === 1 ? {} : undefined,
      file: card.step === 1 ? null : undefined,
    }));
  }

  return apiSteps.map((step) => {
    const card = cards.find((item) => item.step === step.step);
    return card?.title ? { ...step, title: card.title } : step;
  });
};

export const getActiveFormSections = (forms, companyType = 'LLC') => {
  const form = forms?.[companyType] || forms?.LLC;
  if (!form?.sections?.length) return [];
  return form.sections
    .filter((section) => section.isActive !== false)
    .map((section, index) => ({
      ...section,
      sectionOrder: section.sectionOrder ?? index,
      questions: (section.questions || [])
        .filter((q) => q.isActive !== false)
        .map((q, qi) => ({ ...q, order: q.order ?? qi })),
    }))
    .filter((section) => section.questions.length > 0);
};

export const buildLegacyFormQuestions = (sections) => {
  const formQuestions = {};
  const questionMeta = {};

  sections.forEach((section) => {
    formQuestions[section.sectionTitle] = section.questions.map((q) => q.text);
    section.questions.forEach((q, index) => {
      questionMeta[`${section.sectionTitle}-${index}`] = q;
    });
  });

  return { formQuestions, questionMeta };
};

export const countActiveQuestions = (sections) =>
  sections.reduce((total, section) => total + (section.questions?.length || 0), 0);

export const getStepCardMeta = (stepCards, step) =>
  stepCards.find((item) => item.step === step) || {};
